<template>
    <li v-if="showConfirmEmail">
        {{ $t('coupon.confirmEmail') }} {{ appointment.clientData.email }}
    </li>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'coupon-confirm-email',
    props: {
        appointment: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            getSendByEmail: 'metadataForm/getSendByEmail',
        }),

        /**
         * Returns true if there are client data associated with the appointment
         */
        hasClientData() {
            return this.appointment && this.appointment.clientData;
        },

        /**
         * Returns true the patient has ask for an email and he has enter an email
         */
        showConfirmEmail() {
            return this.getSendByEmail && this.hasClientData && this.appointment.clientData.email;
        },
    },
};
</script>
